import { Alert, Button, Stack } from '@mui/material';
import { useEffect } from 'react';
import { endSupportSession, getSessionClaims } from '../apiClient.ts';

// Back to the platform admin's own session, on a fresh page.
const exitSupportSession = () => {
  endSupportSession();
  window.location.hash = '#/platform';
  window.location.reload();
};

/** Top of every page in a support session: whose workspace this is, and the way out. */
const SupportBanner = () => {
  const claims = getSessionClaims();
  const endsAt = claims?.exp ? claims.exp * 1000 : null;

  // The hour runs out on its own: come back rather than wait for a request to fail.
  useEffect(() => {
    if (!endsAt) return;
    const timer = window.setTimeout(exitSupportSession, Math.max(endsAt - Date.now(), 0));
    return () => window.clearTimeout(timer);
  }, [endsAt]);

  const until = endsAt
    ? new Date(endsAt).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
    : null;

  return (
    <Alert
      severity="warning"
      sx={{ mt: 1, mb: 2, '& .MuiAlert-message': { flex: 1, minWidth: 0 } }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={1}
        sx={{ alignItems: { xs: 'flex-start', md: 'center' }, justifyContent: 'space-between' }}
      >
        <span>
          Support session: you are in {claims?.supportTenant ?? 'this workspace'} as {claims?.email}
          . Changes are saved as them.{until ? ` It ends at ${until}.` : ''}
        </span>
        <Button
          color="inherit"
          size="small"
          variant="outlined"
          onClick={exitSupportSession}
          sx={{ flexShrink: 0, whiteSpace: 'nowrap' }}
        >
          Exit
        </Button>
      </Stack>
    </Alert>
  );
};

export default SupportBanner;
